
import React from 'react';
import { Box, Dialog } from '@mui/material';

export default function InfoDialog({ open, onClose }:{ open:boolean; onClose:()=>void }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box sx={{ bgcolor:'#0b1020', color:'#e5ecff', p:2 }}>
        <Box sx={{ fontSize: 18, fontWeight: 700, mb: 1 }}>About</Box>
        <Box sx={{ opacity: 0.9, lineHeight: 1.4 }}>
          Hierarchical, doubles-first map of Pickleball skills. Overview uses a solar-system layout; click any planet to open its full, zoomable tree.
          Each skill has quick tips and a one-click Google search for drill videos. Use level buttons to see prioritized leaves.
        </Box>
      </Box>
    </Dialog>
  );
}
